import styled from '@emotion/styled'
import { ReactNode } from 'react'
import { faClose } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const V2L2ModalTitlebarRoot = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	backgroundColor: theme.colors.white,
	padding: '0.5rem 1rem',
	minHeight: '2rem',
}))

const Title = styled.div(({theme}) => ({
	...theme.fonts.titleBold,
	display: 'flex',
	flexDirection: 'row',
	columnGap: '0.5rem',
}))

const Buttons = styled.div({
	display: 'flex',
	flexDirection: 'row',
	columnGap: '0.5rem',
})

interface V2L2ModalTitlebarProps {
	title: ReactNode
	buttons: ReactNode
}

export const V2L2ModalTitlebar = ({title, buttons}: V2L2ModalTitlebarProps) => {
	return (
		<V2L2ModalTitlebarRoot>
			<Title>{title}</Title>
			<Buttons>{buttons}</Buttons>
		</V2L2ModalTitlebarRoot>
	)
}

const V2L1ModalDismissButtonRoot = styled.button(({theme}) => ({
	all: 'unset',
	cursor: 'pointer',
	borderRadius: theme.borderRadius,
	overflow: 'hidden',
	backgroundColor: theme.colors.second,
	fontSize: `${12/16}rem`,
	padding: '0.5rem',
}))

interface V2L1ModalDismissButtonProps {
	onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const V2L1ModalDismissButton = ({onClick}: V2L1ModalDismissButtonProps) => {
	return (
		<V2L1ModalDismissButtonRoot onClick={onClick}>
			<FontAwesomeIcon fixedWidth icon={faClose} />
		</V2L1ModalDismissButtonRoot>
	)
}
